import styled from 'styled-components';
export const Subtitle = styled.h3`
  margin-bottom: 25px;
  margin-left: -8px;
  margin-right: -8px;
`;
